import { getLocationPath } from '@web/features/locations/utils/locationPath'

const HOST_SITE: Record<string, string> = {
  'gestion.trouvetonrefuge.com': 'https://trouvetonrefuge.com',
  'manage.findyourhut.com': 'https://findyourhut.com',
}

/** Adresse du site public : VITE_PUBLIC_SITE_URL, sinon le domaine qui correspond au site de gestion. */
export function publicSiteBase(): string {
  const fromEnv = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined)?.trim()
  if (fromEnv) return fromEnv.replace(/\/+$/, '')
  return HOST_SITE[window.location.hostname.toLowerCase()] ?? 'https://trouvetonrefuge.com'
}

export function publicSiteUrl(path: string): string {
  return `${publicSiteBase()}${path.startsWith('/') ? path : `/${path}`}`
}

/** Lien vers la fiche publique d'un élément (refuge, camping, organisation…). */
export function publicLocationUrl(location: { id: number; type: string; slug?: string | null }): string {
  return publicSiteUrl(getLocationPath(location))
}

/** Fiche publique d'un sentier officiel (itinéraire ou tracé autonome). */
export function publicTrailUrl(item: { kind: 'itinerary' | 'track'; ref?: string | null; public_id?: string | null; slug?: string | null }): string {
  const ref = item.ref || item.slug || item.public_id
  if (item.kind === 'track') return publicSiteUrl(`/traces/track/${ref}`)
  return publicSiteUrl(`/itineraries/${ref}`)
}

/** Nouveau tracé dans le planificateur du site public. */
export function publicPlannerUrl(): string {
  return publicSiteUrl('/planning/transport')
}

const WIZARD_URL_STEP: Record<string, string> = {
  transport: 'transport',
  'route-type': 'tracktype',
  auto: 'auto',
  track: 'track',
  pois: 'pois',
  accommodations: 'accommodations',
  'alternate-points': 'alternatepoints',
  resume: 'resume',
  completed: 'resume',
}

/** Reprendre un itinéraire officiel dans le planificateur (étape actuelle). */
export function publicPlannerEditUrl(item: { id: number; wizard_step?: string | null }): string {
  const step = WIZARD_URL_STEP[item.wizard_step || ''] || 'resume'
  return publicSiteUrl(step === 'transport' ? `/planning/transport/${item.id}` : `/planning/${step}/${item.id}`)
}

/** Étape POI du planificateur, pour ajouter des points d'intérêt. */
export function publicPlannerPoisUrl(item: { id: number }): string {
  return publicSiteUrl(`/planning/pois/${item.id}`)
}
